import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "label", "successLabel", "disabledLabel", "isSuccess", "isDisabled", "isPending", "isLight", "isOutline", "pendingLabel", "color", "onClick", "type", "theme", "icon", "classes"];
/* eslint-disable complexity */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import ActionButton from '../../ActionButton';
import withMemo from '../../../decorators/withMemo';
import icons from '../../Icon/icons';
import { useSafeCall } from '../../../helpers/React';
import { mergeStyles } from '../../../utils/StyleUtils';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Submit = function Submit(props) {
  var className = props.className,
    label = props.label,
    successLabel = props.successLabel,
    disabledLabel = props.disabledLabel,
    isSuccess = props.isSuccess,
    isDisabled = props.isDisabled,
    isPending = props.isPending,
    isLight = props.isLight,
    isOutline = props.isOutline,
    pendingLabel = props.pendingLabel,
    color = props.color,
    onClick = props.onClick,
    type = props.type,
    theme = props.theme,
    icon = props.icon,
    classesProp = props.classes,
    otherProps = _objectWithoutProperties(props, _excluded);
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  var labelText = isPending && pendingLabel ? pendingLabel : isSuccess && successLabel ? successLabel : isDisabled && disabledLabel ? disabledLabel : label;
  var handleClick = useSafeCall(onClick);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className, isPending && !isSuccess && classes.pending)
  }, /*#__PURE__*/React.createElement(ActionButton, _extends({
    color: color,
    label: labelText,
    className: cx(classes.button, isPending && classes.pending),
    isDisabled: isDisabled,
    isSuccess: isSuccess || isPending,
    icon: isPending ? icons.Refresh : isSuccess ? icons.Check : icon,
    onClick: handleClick,
    type: type,
    theme: theme
  }, otherProps)));
};
Submit.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.string,
  successLabel: PropTypes.string,
  disabledLabel: PropTypes.string,
  pendingLabel: PropTypes.string,
  isSuccess: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isPending: PropTypes.bool,
  isLight: PropTypes.bool,
  isOutline: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.func
};
Submit.defaultProps = {
  classes: {},
  className: '',
  label: '',
  color: '',
  theme: 'primary',
  type: 'submit',
  successLabel: '',
  disabledLabel: '',
  pendingLabel: '',
  isSuccess: false,
  isDisabled: false,
  isPending: false,
  isLight: false,
  isOutline: false,
  onClick: function onClick() {
    return null;
  },
  icon: null
};
export default withMemo()(Submit);